export default{sources:{avif:"__VITE_ASSET__CoMKR2ym__ 400w",webp:"__VITE_ASSET__BcVhHlwb__ 400w"},img:{src:"__VITE_ASSET__huQcTAtr__",w:400,h:300}};